import * as angular from 'angular';
import Inputmask from 'inputmask';

angular
  .module('screeningcanvas')
  .directive('percentageMask', function () {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, element, attrs, ngModelCtrl) {
        Inputmask("999,99", {
          numericInput: true,
          greedy: false,
          placeholder: '',
        }).mask(element);

        ngModelCtrl.$formatters.push(function (value) {
          return (!!value || value === 0)
            ? value.toFixed(2).toString().replace(/\./, ',')
            : null;
        });
        ngModelCtrl.$parsers.push(function (value) {
          if (/(\ ,|,\ |^,|^$)/.test(value))
            return null;
          return parseFloat(value.replace(/,/, '.').replace(/\ |,/g, ''));
        });
      }
    };
  });
